import ACTION_ITEMS from '../actionItems';

const initialState = {
  message: ''
};

export const loginFormReducer = function (state = initialState, action) {
  switch (action.type) {
    case ACTION_ITEMS.LOGIN.FAILURE:
      state = Object.assign({}, state, { message: action.payload.message });
      break;

    default:
      break;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/pages/login/components/loginForm/reducers/loginFormReducer.js